<template>
  <div class="md:mx-4 lg:mx-8 text-dark">
    <div class="text-center ">

      <div v-if="!firstExperience.sentiment" class="mb-4">
              <div class="flex items-center justify-center">
        <img src="@/assets/images/meditation.png" alt="Image" class="mx-auto w-2/3">
      </div>
        <h1 class="text-5xl font-black text-black">how is your first experience?</h1>

         <div class="flex justify-center mt-2">
            <vs-button icon-pack="feather" size="small" icon="icon-thumbs-down" class="mt-2 mx-2 text-sm text-center cursor-pointer hover:underline" @click="firstExperience.sentiment = 'not so good'">not so good</vs-button>

           <vs-button icon-pack="feather" size="small" icon="icon-thumbs-up" class="mt-2 mx-2 text-sm text-center cursor-pointer hover:underline" @click="firstExperience.sentiment = 'good'">good</vs-button>
         </div>

      </div>

       <div v-if="firstExperience.sentiment">
         <div>
            <p class="text-left font-bold">How easy is it to navigate and use improvee.io?</p>

            <div class="">
             <div class="flex text-grey">
              <div class="flex justify-start w-1/2">
                 not so good
              </div>
              <div class="flex justify-end w-1/2">
                 good
              </div>
             </div>

            <vs-slider
              v-model="firstExperience.navigation"
              color="black"
              :step="1"
              max="10"
              :height="40"
              class="m-1"
              />
            </div>
         </div>

         <div class="mt-8">
            <p class="text-left font-bold">Does improvee.io provide the solution for what you were looking for?</p>

            <div class="">
             <div class="flex text-grey">
              <div class="flex justify-start w-1/2">
                 not at all
              </div>
              <div class="flex justify-end w-1/2">
                 very likely!
              </div>
             </div>

              <vs-slider
                v-model="firstExperience.solution"
                color="black"
                :step="1"
                max="10"
                :height="40"
                class="m-1"
                />
            </div>
         </div>

         <div class="mt-8">
            <p class="text-left font-bold">How well does improvee.io fit into your overall plan for personal growth?</p>


            <div class="">
             <div class="flex text-grey">
              <div class="flex justify-start w-1/2">
                 not very much
              </div>
              <div class="flex justify-end w-1/2">
                 completely
              </div>
             </div>

            <vs-slider
              v-model="firstExperience.growth"
              color="black"
              :step="1"
              max="10"
              :height="40"
              class="m-1"
              />
            </div>
         </div>

         <div class="mt-8">
            <p class="text-left font-bold">How likely are you to recommend improvee.io to a friend or colleague?</p>

            <div class="">
                <div class="flex text-grey">
                <div class="flex justify-start w-1/2">
                  not very likely
                </div>
                <div class="flex justify-end w-1/2">
                   doing it right now!
                </div>
               </div>

              <vs-slider
                v-model="firstExperience.recommend"
                color="black"
                :step="1"
                max="10"
                :height="40"
                class="m-1"
                />
            </div>

         </div>

         <div class="mt-8">
            <p class="text-left font-bold">Do you have any additional feedback or comments?</p>

        <vs-input
                v-model="firstExperience.additionalText"
                placeholder=""
                class="w-full"
                autocomplete="off"
            />

         </div>

        <vs-button class="mt-2 text-sm text-center cursor-pointer hover:underline" @click="save">save</vs-button>
       </div>

    </div>
  </div>
</template>

<script>

export default {
  components: {
  },
  data () {
   return {
      firstExperience: {
        sentiment: null,
        navigation: null,
        solution: null,
        growth: null,
        recommend: null,
        additionalText: null
      }
    }
  },
  computed: {
  },
  methods: {
    save () {
      this.$store.dispatch('UPDATE_USER_PARTIALLY', { firstExperience: this.firstExperience })
      this.$emit('hidePopup')
    }
  }
}
</script>
